import React from "react";

import { SupHeading, SupText } from "@repo/core-ui";

export default function UiLabelSuperPoolPositionTooltip() {
  return (
    <div className="space-y-2">
      <div className="inline-flex w-full flex-nowrap items-center space-x-1 text-neutral-900">
        <SupHeading variant="h6">ERC-20</SupHeading>
      </div>
      <SupText variant="subtitle1" as="div" className="text-neutral-900">
        This SuperPosition is an ERC-20 position.
      </SupText>
    </div>
  );
}
